import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckBox from '../../../../../components/ZUILib/CheckBox';
import * as notificacionesActions from './actions';
import * as labelsActions from '../../../../../components/labels/actions';
import ApplyCSS from '../../../../../components/ApplyCSS';

import * as defaultConst from '../../../../../utils/clientConstant';

const { loadNotificacionesPage } = notificacionesActions;
const { isLablesLoaded, loadLables } = labelsActions;

const pageName = 'notificaciones';

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  store,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  {
    ...notificacionesActions,
  })

class Notificaciones extends Component {

  UNSAFE_componentWillMount() {
    const user = this.props.user;
    if (!(user && user.result && user.result.status && user.result.status.status === defaultConst.constAPISuccess)) {
      if (browserHistory) {
        browserHistory.push('/');
      }
    }

    this.props.loadNotificacionesPage();
  }

  render() {
    const { notificaciones } = this.props;
    if (notificaciones && notificaciones.notificaciones) {
      return (
        <div>
          <ApplyCSS pageName={pageName} />
          <div className="col-md-9 oppeningContainer">
            <div className="col-md-12">
              <h1 className="titleSection">Notificaciones</h1>
              <p className="descriptiveText">Las notificaciones relacionadas a tu cuenta no pueden ser desactivadas</p>
              <p className="subtitleSection">Correo electrónico</p>
              {/* <div className="checkbox"> */}
              {notificaciones.notificaciones.map((CheckBoxValues, index) =>
                <CheckBox key={index} id={CheckBoxValues.id} value={CheckBoxValues.id} displayName={CheckBoxValues.displayName} />,
              )}
              {/* </div> */}
            </div>
          </div>
        </div>
      );
    } return null;
  }
}

const mapStateToProps = state => ({
  lables: state.labels.data,
  notificaciones: state.notificaciones.data,
  user: state.user.data,
});

const matchDispatchToProps = dispatch => bindActionCreators({ loadNotificacionesPage }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Notificaciones);
